import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import error404 from '~/assets/images/maintenance/hoag_error.png';
import { APP_DEFAULT_PATH } from '~/config';

function Error404() {
  return (
    <>
      <Grid
        container
        spacing={10}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh', pt: 1.5, pb: 1, overflow: 'hidden' }}
      >
        <Grid item xs={12}>
          <Stack direction="row">
            <Grid item>
              <Box sx={{ width: { xs: 250, sm: 590 }, height: { xs: 130, sm: 400 } }}>
                <img
                  src={error404}
                  alt="mantis"
                  style={{ width: '100%', height: '100%', borderRadius: 6 }}
                />
              </Box>
            </Grid>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Typography variant="h1">Bad Trades Happen.</Typography>
            <Typography
              color="textSecondary"
              align="center"
              sx={{ width: { xs: '73%', sm: '61%' } }}
            >
              Luckily - this wasn't one. Just the page you are looking for was moved, removed,
              renamed, or might never have existed!
            </Typography>
            <Button component={Link} to={APP_DEFAULT_PATH} variant="contained">
              Back To Home
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default Error404;
